export const classes = [
	{
        id: "C138038",
        class: "I",
        section: "A",
        noOfStudents: 30,
        noOfSubjects: 0o3,
        status: "Active",
        key:1
      },
      {
        id: "C138037",
        class: "I",
        section: "B",
        noOfStudents: 25,
        noOfSubjects: 0o3,
        status: "Active",
        key:2
      },
      {
        id: "C138036",
        class: "II",
        section: "A",
        noOfStudents: 40,
        noOfSubjects: 0o3,
        status: "Active",
        key:3
      },
      {
        id: "C138035",
        class: "II",
        section: "B",
        noOfStudents: 35,
        noOfSubjects: 0o3,
        status: "Active",
        key:4
      },
      {
        id: "C138034",
        class: "II",
        section: "C",
        noOfStudents: 25,
        noOfSubjects: 0o3,
        status: "Inactive",
        key:5
      },
      {
        id: "C138033",
        class: "III",
        section: "A",
        noOfStudents: 30,
        noOfSubjects: 0o3,
        status: "Active",
        key:6
      },
      {
        id: "C138032",
        class: "III",
        section: "B",
        noOfStudents: 25,
        noOfSubjects: 0o5,
        status: "Active",
        key:7
      },
      {
        id: "C138031",
        class: "IV",
        section: "A",
        noOfStudents: 20,
        noOfSubjects: 0o5,
        status: "Active",
        key:8
      },
      {
        id: "C138030",
        class: "IV",
        section: "B",
        noOfStudents: 30,
        noOfSubjects: 0o5,
        status: "Inactive",
        key:9
      },
      {
        id: "C138029",
        class: "V",
        section: "A",
        noOfStudents: 35,
        noOfSubjects: 0o5,
        status: "Active",
        key:10
      }
];
